module.exports = __webpack_public_path__ + "img/miniProgram.175173b0.jpg";